import {
  DocumentsSignatureStatusEnumValues,
  FilterType,
  buildDocumentsDataTableFilter,
  useDocumentsDataTable,
} from 'generated/resources/datatable.graphql'

import i18n from 'modules/core/lib/i18n'

import SignatureStatusTag from 'modules/documents/components/Documents/List/Item/SignatureStatusTag'
import { documentSignatureStatusLabel } from 'modules/documents/lib/Documents'

const statusFilter = (source: ReturnType<typeof useDocumentsDataTable>) => {
  const options = DocumentsSignatureStatusEnumValues.map((status) => ({
    label: documentSignatureStatusLabel(status),
    value: status,
    component: <SignatureStatusTag status={status} />,
  }))

  return buildDocumentsDataTableFilter(source, {
    type: FilterType.String,
    categories: [
      {
        kind: 'MultipleChoice',
        operation: 'in',
        options,
      },
    ],
    identifier: 'signature_status',
    path: 'signatureStatus',
    title: i18n.t('documents.employee.filters.esignature_status'),
  })
}

export default statusFilter
